/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaveRequest } from './LeaveRequest';
import {
    LeaveRequestFromJSON,
    LeaveRequestFromJSONTyped,
    LeaveRequestToJSON,
    LeaveRequestToJSONTyped,
} from './LeaveRequest';

/**
 * 
 * @export
 * @interface UpdateLeaveRequestResponse
 */
export interface UpdateLeaveRequestResponse {
    /**
     * 
     * @type {LeaveRequest}
     * @memberof UpdateLeaveRequestResponse
     */
    data: LeaveRequest;
}

/**
 * Check if a given object implements the UpdateLeaveRequestResponse interface.
 */
export function instanceOfUpdateLeaveRequestResponse(value: object): value is UpdateLeaveRequestResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateLeaveRequestResponseFromJSON(json: any): UpdateLeaveRequestResponse {
    return UpdateLeaveRequestResponseFromJSONTyped(json, false);
}

export function UpdateLeaveRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeaveRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeaveRequestFromJSON(json['data']),
    };
}

  export function UpdateLeaveRequestResponseToJSON(json: any): UpdateLeaveRequestResponse {
      return UpdateLeaveRequestResponseToJSONTyped(json, false);
  }

  export function UpdateLeaveRequestResponseToJSONTyped(value?: UpdateLeaveRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeaveRequestToJSON(value['data']),
    };
}

